import {createAction} from 'redux-act';

export const setErrorVisibility = createAction<boolean>('SET_ERROR_VISIBILITY');
